import { render, staticRenderFns } from "./OrgSubscriptions.vue?vue&type=template&id=4094a602&scoped=true"
import script from "./OrgSubscriptions.vue?vue&type=script&lang=js"
export * from "./OrgSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./OrgSubscriptions.vue?vue&type=style&index=0&id=4094a602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094a602",
  null
  
)

export default component.exports